import { render, staticRenderFns } from "./TicketCreateView.vue?vue&type=template&id=1bef7e0c"
import script from "./TicketCreateView.vue?vue&type=script&lang=js"
export * from "./TicketCreateView.vue?vue&type=script&lang=js"
import style0 from "./TicketCreateView.vue?vue&type=style&index=0&id=1bef7e0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports